<template>
  <div
    :class="[
      $style.play_button,
      isHovered ? $style.play_button_hovered : '',
    ]"
  >
    <div :class="$style.play_button__circle">
      <div :class="$style.play_button__triangle" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlayButton',
  props: {
    isHovered: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style module lang="less">
@import "../../../../../../less/_variables.less";
@import "../../../../../../less/_mixins.less";

.play_button {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 40px;
  height: 40px;
  // Тень из макета (popupShadow)
  filter: drop-shadow(0px 9px 22px rgba(0, 0, 0, 0.2));

  &__circle {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #FFFFFF;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.2s ease;
  }

  &__triangle {
    position: absolute;
    width: 0;
    height: 0;
    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;
    border-left: 10px solid #191919;
    transform: translateX(2px);
  }

  &:hover &__circle,
  &_hovered &__circle {
    transform: scale(1.2); // 40px * 1.2 = 48px
  }
}
</style>

